module.exports = __webpack_public_path__ + "static/img/Emilie.e258fee.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/staff/Emilie.jpg
// module id = 200
// module chunks = 1